module.exports = __webpack_public_path__ + "img/logo_GI_blu_en.a98fdeb2.png";